// src/pages/Ads/Components/PolicyVersionSelectSheet.jsx
import React, { useEffect, useState } from "react";
import { Bottom } from "../../../../assets/components/BottomSheetGroup";
// 🔥 이제 하단 버튼 안 쓰니까 삭제해도 됨
// import { SplitRowQuarter } from "../../../../assets/components/ButtonGroup";
// 라디오 아이콘도 안 쓰면 같이 정리 가능
// import radio_checked from "../../../../assets/icons/Select/radio_checked.svg";
// import radio_unchecked from "../../../../assets/icons/Select/radio_unchecked.svg";

export default function PolicyVersionSelectSheet({
    isOpen,
    onClose,
    versions = [],   // [{ policy_id, version_label, is_active, ... }]
    value,           // 현재 선택된 row (AdsPolicy의 selected)
    onConfirm,       // onConfirm(selectedRow)
}) {
    const [selectedId, setSelectedId] = useState(null);

    // 시트가 열릴 때마다 기본 선택값 초기화
    useEffect(() => {
        if (!isOpen) return;

        if (value && value.policy_id) {
            setSelectedId(value.policy_id);
            return;
        }

        if (versions.length > 0) {
            const active = versions.find((v) => v.is_active) || versions[0];
            setSelectedId(active.policy_id);
            return;
        }

        setSelectedId(null);
    }, [isOpen, value, versions]);

    const handleClose = () => {
        onClose && onClose();
    };

    // 🔥 클릭 시 바로 선택 + 닫기
    const handleSelect = (policyId) => {
        const row = versions.find((v) => v.policy_id === policyId);
        if (!row) return;

        setSelectedId(policyId);   // 다음에 열릴 때 하이라이트용
        onConfirm && onConfirm(row);
        onClose && onClose();
    };

    return (
        <Bottom
            isOpen={isOpen}
            onClose={handleClose}
            title="버전 선택"
            height="h-64"
        >
            <div className="flex flex-col h-full">
                {/* 리스트 영역 */}
                <div className="flex-1 flex flex-col gap-[8px] overflow-y-auto">
                    {versions.length === 0 && (
                        <p className="text-c2 text-text-subtler py-[8px]">
                            선택할 수 있는 버전이 없습니다.
                        </p>
                    )}

                    {versions.map((v) => {
                        const isSelected = selectedId === v.policy_id;
                        const label = v.is_active
                            ? `[현행] ${v.version_label}`
                            : v.version_label;

                        return (
                            <button
                                key={v.policy_id}
                                type="button"
                                onClick={() => handleSelect(v.policy_id)}
                                className={
                                    "flex items-center justify-between w-full px-[16px] py-[12px] rounded-[12px] border transition-all gap-[8px] " +
                                    (isSelected
                                        ? "border-btn-secondary-border bg-surface-light-primary-light"
                                        : "border-btn-disabled-fill bg-surface-light-white")
                                }
                            >
                                <div className="flex items-center gap-3">
                                    <span
                                        className={
                                            "text-b1 " +
                                            (isSelected ? "text-text-default" : "text-text-subtler")
                                        }
                                    >
                                        {label}
                                    </span>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
        </Bottom>
    );
}
